module.exports = __webpack_public_path__ + "img/sec2_15.59df2c44.png";